import React, { useState } from 'react';

const NaverNews = () => {
  const [formData, setFormData] = useState({
    query: '주식',
    display: '10',
    start: '1',
    sort: 'date'
  });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  // 정렬 옵션
  const sortOptions = [
    { value: 'date', label: '날짜순' },
    { value: 'sim', label: '관련도순' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const params = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        if (value && value.trim() !== '') {
          params.append(key, value.trim());
        }
      });

      const response = await fetch(`/api/naver/news?${params.toString()}`);
      const data = await response.json();

      if (data.success) {
        setResult(data);
      } else {
        setError(data.message || 'API 호출 실패');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '날짜 없음';
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const removeHtmlTags = (html) => {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '');
  };

  return (
    <div className="naver-news-tester">
      <div className="header">
        <h2>📰 네이버 뉴스 API</h2>
        <p>네이버 검색 API를 통해 주식 관련 뉴스를 검색합니다.</p>
      </div>

      <div className="control-section">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="query">검색어:</label>
            <input
              type="text"
              id="query"
              name="query"
              value={formData.query}
              onChange={handleInputChange}
              placeholder="검색어를 입력하세요 (예: 주식, 삼성전자, 코스피)"
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="display">결과 수:</label>
              <select
                id="display"
                name="display"
                value={formData.display}
                onChange={handleInputChange}
              >
                <option value="5">5개</option>
                <option value="10">10개</option>
                <option value="20">20개</option>
                <option value="50">50개</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="start">시작 위치:</label>
              <input
                type="number"
                id="start"
                name="start"
                value={formData.start}
                onChange={handleInputChange}
                min="1"
                max="1000"
              />
            </div>

            <div className="form-group">
              <label htmlFor="sort">정렬:</label>
              <select
                id="sort"
                name="sort"
                value={formData.sort}
                onChange={handleInputChange}
              >
                {sortOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? '검색 중...' : '🔍 뉴스 검색'}
          </button>
        </form>
      </div>

      {error && (
        <div className="error-section">
          <h3>❌ 오류</h3>
          <p>{error}</p>
        </div>
      )}

      {result && (
        <div className="result-section">
          <div className="result-info">
            <h3>📊 검색 결과</h3>
            <p>
              검색어: <strong>{result.query}</strong> | 
              결과 수: <strong>{result.result.items?.length || 0}</strong>개 | 
              총 결과: <strong>{result.result.total || 0}</strong>개
            </p>
          </div>

          <div className="news-grid">
            {result.result.items?.map((item, index) => (
              <div key={index} className="news-card">
                <div className="news-header">
                  <h4 className="news-title">
                    <a 
                      href={item.link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                  </h4>
                  <span className="news-source">{item.originallink}</span>
                </div>
                <p className="news-description" 
                   dangerouslySetInnerHTML={{ __html: item.description }} />
                <div className="news-footer">
                  <span className="news-date">{formatDate(item.pubDate)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="info-section">
        <h3>ℹ️ 사용법</h3>
        <ul>
          <li><strong>검색어</strong>: 주식 관련 키워드 입력 (예: 주식, 삼성전자, 코스피, KOSPI)</li>
          <li><strong>결과 수</strong>: 한 번에 가져올 뉴스 개수 (최대 50개)</li>
          <li><strong>시작 위치</strong>: 검색 결과의 시작 위치 (페이지네이션용)</li>
          <li><strong>정렬</strong>: 날짜순 또는 관련도순으로 정렬</li>
        </ul>
        
        <h4>📋 API 제한사항</h4>
        <ul>
          <li>하루 25,000건 호출 제한 (무료)</li>
          <li>한 번에 최대 100개 결과 (display=100)</li>
          <li>검색어는 2글자 이상</li>
        </ul>
      </div>
    </div>
  );
};

export default NaverNews;

